import React from "react";
import Paper from "@material-ui/core/Paper";
import Style from "../../styles/js/StyleNotifications.js";
import Typography from "@material-ui/core/Typography";
import CellPhone from "./CellPhone.js";
import PreviewButtons from "./PreviewButtons.js";
import * as ScreenText from "../../consts/ScreenText.js";

export default function NotificationPreview({ state }) {
  const style = Style();

  const [view, setView] = React.useState(0);

  const handleChange = (event, newValue) => {
    setView(newValue);
  };

  return (
    <Paper className={style.notificationsForm}>
      <Typography variant="h4" gutterBottom>
        {ScreenText.NOTIFICATIONS_PREVIEW_TITLE}
      </Typography>
      <Typography variant="h7" gutterBottom>
        {ScreenText.NOTIFICATIONS_PREVIEW_MESSAGE}
      </Typography>
      <PreviewButtons view={view} handleChange={handleChange} />
      <CellPhone
        view={view}
        title={state.title}
        body={state.body}
        link={state.link}
        image={state.image}
      />
    </Paper>
  );
}
